import {getPosterHashedIdForAiChatImageAsset} from '@Components/ai-chat-window/lib/chat-attachment-image.library';
import {showMessageGrowl, updateGrowlProgress, GROWL_TYPE} from '@Components/message-growl';
import {GA4EventName} from '@Libraries/ga-events';

const SAVE_GROWL_KEY = 'save-to-my-designs';
const PROGRESS_DURATION_MS = 15000;
const PROGRESS_STEPS = 60;
const PROGRESS_MAX = 90;
const GROWL_LOADING_INTERVAL = 120000;

const startSmoothProgress = (): ReturnType<typeof setInterval> => {
  let progress = 0;
  const intervalTime = PROGRESS_DURATION_MS / PROGRESS_STEPS;
  const progressIncrement = PROGRESS_MAX / PROGRESS_STEPS;

  return setInterval(() => {
    progress += progressIncrement;
    updateGrowlProgress(SAVE_GROWL_KEY, Math.min(progress, PROGRESS_MAX));
  }, intervalTime);
};

/** An own design, or the copy made of a gallery template, already is a poster in My Designs, so saving only confirms it. */
export const confirmUserDesignSaved = (): void => {
  window.PMW.gtm.trackGA4CustomEvent(GA4EventName.AICHAT_SAVE_TO_MY_DESIGNS);

  showMessageGrowl({
    key: SAVE_GROWL_KEY,
    text: window.i18next.t('pmwjs_file_saved'),
    type: GROWL_TYPE.SUCCESS,
  });
};

export const saveAiChatImageToMyDesigns = async (imageHashedId: string): Promise<void> => {
  window.PMW.gtm.trackGA4CustomEvent(GA4EventName.AICHAT_SAVE_TO_MY_DESIGNS);

  showMessageGrowl({
    key: SAVE_GROWL_KEY,
    text: window.i18next.t('pmwjs_saving_to_my_designs'),
    type: GROWL_TYPE.NEUTRAL,
    showCloseIcon: true,
    interval: GROWL_LOADING_INTERVAL,
    progress: 0,
  });

  const progressInterval = startSmoothProgress();

  try {
    await getPosterHashedIdForAiChatImageAsset(imageHashedId);

    showMessageGrowl({
      key: SAVE_GROWL_KEY,
      text: window.i18next.t('pmwjs_file_saved'),
      type: GROWL_TYPE.SUCCESS,
    });
  } catch (e: unknown) {
    showMessageGrowl({
      key: SAVE_GROWL_KEY,
      text: window.i18next.t('pmwjs_something_went_wrong'),
      type: GROWL_TYPE.DANGER,
    });

    throw e;
  } finally {
    clearInterval(progressInterval);
  }
};
